import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { useWallAnalytics, useWallProvider } from "@package/ui-wall";
import { MediaDisplay } from "@package/ui-wall-components";
import { get } from "lodash";
import { useCallback, useMemo } from "react";
import { type FlyoutProps } from "../../utils/flyout-props";

export function FlyoutStandard({ screen }: FlyoutProps) {
  const provider = useWallProvider();
  const { trigger } = useWallAnalytics();
  const media = useMemo<string | undefined>(
    () =>
      get(screen.flyout?.post, "customData.flyout.standard.media") ?? undefined,
    [screen.flyout?.post],
  );

  const onHandleMouse = useCallback(
    (x: number, y: number) => {
      provider?.onFlyoutClosed(screen.id);
      trigger(
        EventPayloadType.PostClosed,
        {
          position: {
            x,
            y,
          },
          screen: screen.index,
        },
        screen.flyout?.post?.id ?? undefined,
        screen.layout?.id ?? undefined,
      );
    },
    [
      provider,
      screen.flyout?.post?.id,
      screen.id,
      screen.index,
      screen.layout?.id,
      trigger,
    ],
  );

  return (
    <div className="relative h-full w-full">
      <MediaDisplay id={media} />
      <div
        className="absolute top-0 left-0 w-full h-full"
        onPointerDown={(e) => onHandleMouse(e.screenX, e.screenY)}
      />
    </div>
  );
}
